import clsx from "clsx";
import { categoryLabel, priorityLabel, statusLabel } from "@/lib/supportTickets";

const STATUS_STYLES: Record<string, string> = {
  open: "bg-status-orange/15 text-status-orange",
  in_progress: "bg-accent-soft text-accent",
  waiting: "bg-amber-500/15 text-amber-700 dark:text-amber-400",
  resolved: "bg-status-green/15 text-status-green",
  closed: "bg-fill-tertiary text-label-secondary",
};

const PRIORITY_STYLES: Record<string, string> = {
  low: "bg-fill-tertiary text-label-secondary",
  normal: "bg-accent-soft text-accent",
  high: "bg-status-orange/15 text-status-orange",
  urgent: "bg-status-red/15 text-status-red",
};

function Pill({ className, children }: { className?: string; children: string }) {
  return (
    <span
      className={clsx(
        "inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium",
        className,
      )}
    >
      {children}
    </span>
  );
}

export function TicketStatusBadge({ status }: { status: string }) {
  return <Pill className={STATUS_STYLES[status]}>{statusLabel(status)}</Pill>;
}

export function TicketPriorityBadge({ priority }: { priority: string }) {
  return <Pill className={PRIORITY_STYLES[priority]}>{priorityLabel(priority)}</Pill>;
}

export function TicketCategoryBadge({ category }: { category: string }) {
  return <Pill className="bg-fill-secondary text-label">{categoryLabel(category)}</Pill>;
}
